'use client'

import {
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider
} from '@/lib/transformers'
import { SectionCtaSingle, SectionFeature, SectionSlider } from '@/ui/Sections'

import { Typo3Page, Typo3SectionSpotSanityStory } from '@/types/typo3'
import SpotSanityList from '@/ui/components/SpotSanity/Layouts/SpotSanityListStory'
import { memo, Suspense } from 'react'
import Detail from './Layouts/Detail'

interface Props {
  data: Typo3SectionSpotSanityStory
  pageData: Typo3Page
}

const SpotSanityStory = ({ data, pageData }: Props) => {
  const layout = data?.plugin?.layout
  const variant = 'story'

  switch (layout) {
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(data)
      return <SectionFeature {...sectionData} variant={variant} />
    }
    case 'photo-big': {
      const sectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...sectionData} variant={variant} />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'detail': {
      return <Detail data={data} pageData={pageData} />
    }
    default: {
      return (
        <Suspense>
          <SpotSanityList data={data} />
        </Suspense>
      )
    }
  }
}

export default memo(SpotSanityStory)
